import React from "react";

const BarChart = ({ data, title, color = "bg-primary" }) => {
  if (!data || data.length === 0) return null;

  // Use 'value' as the standard key, fallback to others for compatibility
  const getVal = (item) => item.value ?? item.revenue ?? item.count ?? 0;
  const getLabel = (item) => item.label ?? item.month ?? "";

  const maxValue = Math.max(...data.map(getVal), 1); // Avoid division by zero

  return (
    <div className="bg-white p-4 rounded-xl shadow-sm h-full border border-slate-100 flex flex-col">
      <h3 className="text-sm font-bold text-slate-800 uppercase tracking-tight mb-2">{title}</h3>
      <div className="mt-auto flex justify-between items-end h-48 space-x-2">
        {data.map((item, index) => {
          const val = getVal(item);
          const height = (val / maxValue) * 100;
          
          return (
            <div
              key={index}
              className="flex-1 flex flex-col items-center justify-end group h-full"
            >
              <div className="text-[9px] font-bold text-primary mb-1 opacity-0 group-hover:opacity-100 transition-opacity">
                {val.toLocaleString()}
              </div>
              <div
                className={`w-full ${color} rounded-t-sm opacity-80 group-hover:opacity-100 transition-all duration-300`}
                style={{
                  height: `${height}%`,
                  minHeight: val > 0 ? '2px' : '0px'
                }}
              ></div>
              <span className="text-[9px] text-slate-400 font-medium mt-2 truncate w-full text-center">
                {getLabel(item)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BarChart;
